import { useState } from 'react'
import firebase from '../../../firebase/compat'
import { client } from '../../../hooks/Client'

const WEBHOOK_URL = 'https://europe-west1-deccos-app.cloudfunctions.net/ingestImpactTransaction'

const EXAMPLE_PAYLOAD = `POST ${WEBHOOK_URL}
Headers: x-api-key: <jouw sleutel>
Body: { "amount": 12.50, "orderRef": "order-123", "idempotencyKey": "evt-9" }`

/**
 * Sleutelbeheer voor de generieke transactie-API (Integraties-tab, fase 3).
 * Genereren toont de sleutel éénmalig (alleen de hash wordt opgeslagen);
 * intrekken maakt de sleutel per direct ongeldig.
 * See docs/features/impact-in-beeld-fase3.md.
 */
const ApiKeyBlock = () => {
    const [generatedKey, setGeneratedKey] = useState('')
    const [busy, setBusy] = useState(false)

    const manage = async (action) => {
        setBusy(true)
        try {
            const manageImpactApiKey = firebase.app().functions('europe-west1').httpsCallable('manageImpactApiKey')
            const result = await manageImpactApiKey({ client, action })
            setGeneratedKey(action === 'generate' ? (result.data?.key || '') : '')
        } catch (error) {
            alert(error)
        } finally {
            setBusy(false)
        }
    }

    return (
        <div className='impact-api-key-block'>
            <h3>Transactie-API</h3>
            <p className='impact-in-beeld-tab-intro'>
                Laat je kassa of webshop elke afrekening doorsturen naar dit adres — elk systeem
                dat webhooks of HTTP kan sturen, kan koppelen.
            </p>
            <p className='impact-channel-snippet'>{EXAMPLE_PAYLOAD}</p>
            <div className='impact-channel-copy-row'>
                <button
                    className='impact-in-beeld-add-button'
                    onClick={() => manage('generate')}
                    disabled={busy}
                >
                    Sleutel genereren
                </button>
                <button
                    className='impact-in-beeld-add-button'
                    onClick={() => manage('revoke')}
                    disabled={busy}
                >
                    Sleutel intrekken
                </button>
            </div>
            {generatedKey && (
                <div className='impact-in-beeld-tab-notice'>
                    <p>Je nieuwe sleutel (deze wordt maar één keer getoond — bewaar hem nu):</p>
                    <p className='impact-api-key-value'>{generatedKey}</p>
                </div>
            )}
        </div>
    )
}

export default ApiKeyBlock
